<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-va-optimization-response-line-chart">
    <!-- <div class="view-by">By {{this.type}}</div> -->
    <div ref="chart" class="metrics-chart" />
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';

export default Vue.extend({
  name: 'wy-va-optimization-response-line-chart',
  props: ['data'],

  data() {
    return {
      lineColor: '#1C4DB2',
      legendData: {
        legends: [],
        colors: []
      },
      tickformat: '',
      legendOriginColors: []
    }
  },

  computed: {
    ...mapGetters(['dataModel', 'companyConfig', 'legendDefaultColors']),
  },

  methods: {
    handleDateChange(type){
      if(type == 'year'){
        this.tickformat = '%Y'
      } else if (type == 'quarter'){
        this.tickformat = '%b %d %Y'
      } else if (type == 'week'){
        this.tickformat = '%b %d %Y'
      } else if (type == 'day'){
        this.tickformat = '%b %d %Y'
      } else if (type == 'month'){
        this.tickformat = '%b %Y'
      }
    },
    prepareDataSet(title, dateList, valueList, color) {
      this.legendData.legends.push(title);
      this.legendData.colors.push(color);

      let chartValueList = [];
      if(valueList && valueList.length > 0) {
        valueList.forEach(value => {
          if(value >= 0) {
            chartValueList.push(Math.round(value) + '%')
          }
          else {
            chartValueList.push('N/A'); // if value is -1, return 'N/A'
          }
        });
      }
      let dateset = {
        name: title,
        type: "scatter",
        mode: chartValueList.length > 1 ? "lines" : "lines+markers",
        cliponaxis: false,
        marker: {size: 8},
        line: {
          color: color,
          width: 1
        },
        hoverlabel: {
          namelength: 50,
          font: {
            size: 11,
            color: 'white'
          },
          bordercolor: color,
        },
        x: dateList,
        y: valueList,
        hovertext: chartValueList,
        hovertemplate: "%{hovertext}<extra></extra>" //this.wyChart.hoverTemplateNoDate("d"),
      };

      return dateset;
    },
    
    buildChart(dataList, reRender) {
      let delay = 200;
      if(!reRender) {
        delay = 1000;
      }
      setTimeout(() => {
        if(this.$refs.chart && dataList) {
          // let botOnlyContainedDataset, botOnlyEscalatedDataset, botToLCOnlyDataset, lCOnlyListDataset;
          let botOnlyContainedDataset, botOnlyEscalatedDataset, botToLCOnlyDataset;
          let traces = [];
          if(dataList.handoffRateList) {
            this.legendOriginColors = [];
            if(this.companyConfig && this.companyConfig.legends && this.companyConfig.legends.legendColors && this.companyConfig.legends.legendColors.length > 0) {
              this.legendOriginColors = _.uniq(_.concat(this.companyConfig.legends.legendColors, this.legendDefaultColors));
            }
            else {
              this.legendOriginColors = this.legendDefaultColors
            }
            this.legendData.legends = [];
            this.legendData.colors = [];
            // dataList.handoffRateList = [10, 21, 7]
            // dataList.negativeFeedbackRateList = [2, 11, 50]
            // dataList.botRepetitionRateList = [19, 81, 22]
            // dataList.handoffRateList = [21]
            // dataList.negativeFeedbackRateList = [11]
            // dataList.botRepetitionRateList = [81]
            botOnlyContainedDataset = this.prepareDataSet("Handoff rate", dataList.dateList, dataList.handoffRateList, this.legendOriginColors[0]);
            botOnlyEscalatedDataset = this.prepareDataSet("Negative feedback rate", dataList.dateList, dataList.negativeFeedbackRateList, this.legendOriginColors[1]);
            botToLCOnlyDataset = this.prepareDataSet("Bot repetition rate", dataList.dateList, dataList.botRepetitionRateList, this.legendOriginColors[2]);
            traces = [botOnlyContainedDataset, botOnlyEscalatedDataset, botToLCOnlyDataset];
            if(!reRender) {
              this.$root.$emit(`fire-response-legends-events`, this.legendData)
            }
          }
          traces.forEach(trace => {
            let colors = [];
            trace.x.forEach(() => {
              colors.push('transparent');
            });
            trace.marker = {color: colors, size: 8}
          })
          let layout = {
            autosize: true,
            height: 220,  
            dragmode: false, //'pan'
            separators: '.',
            showlegend: false,
            plot_bgcolor: 'white',
            // hoverlabel: {
            //   namelength: 50,
            //   font: {
            //     size: 11
            //   },
            //   bordercolor: '#FCFEFF'
            // },
            legend: {
              orientation: 'h',
              x: -0.025,
              y: -0.35,
              bgcolor: 'rgba(0,0,0,0)',
              //itemwidth: 50
            },
            margin: { l: 70, r: 40, t: 20, b: 40 },
            xaxis:  {
              // type: 'date',
              tickformat: '%b %d %Y',
              // tickformat: '%b',
              nticks: (dataList.dateList.length > 9 ? 0 : dataList.dateList.length),
              autorange: true,
              showgrid: false,
              zeroline: true,
              automargin: true,
              showline: true,
              linecolor: '#dedede',
              position: 0,
              tickcolor: "transparent",
              title: {
                font: {
                  size: 10,
                  color: 'var(--site-font-tertiary-color)'
                }
              }
            },
            yaxis: {
              type: 'linear',
              autorange: true,
              // rangemode: 'tozero',
              rangemode: 'nonnegative',
              side: 'right',
              separatethousands: true,
              ticksuffix: '%',
              showgrid: true,
              showline: true,
              zeroline: false,
              linecolor: '#dedede',
              layer: 'below traces',
              fixedrange: true,
              tickwidth: 10,
              tickcolor: 'transparent'
            }
          }       

          if(this.type) {
            this.handleDateChange(this.type)
          }
          layout.xaxis.tickformat = this.tickformat;
          if(dataList.dateList.length > 2 && dataList.dateList.length < 5) {
            layout.xaxis.nticks = dataList.dateList.length;
            layout.xaxis.tickformat = this.tickformat;
            if(this.type == 'year') {
              layout.xaxis.tickformat = null;
            }
            if(this.type == 'day') {
              // layout.xaxis.type = 'date'
            }
          }
          if(dataList.dateList.length == 2) {
            // if(this.type == 'day') {
              layout.xaxis.tickmode = 'array';
              layout.xaxis.tickvals = [dataList.dateList[0], dataList.dateList[dataList.dateList.length-1]]
              layout.xaxis.tickformat = this.tickformat;
              // layout.xaxis.type = 'date'
            // }
          }
          if(dataList.dateList.length == 1) {
            layout.xaxis.tickmode = 'array';
            layout.xaxis.tickvals = [dataList.dateList[0]]
            layout.xaxis.nticks = 3;
            traces.forEach((trace, index) => {
              trace.marker.color = this.legendOriginColors[index];
              // trace.marker.color = '#214586';
            })
            if(this.type == 'year') {
              layout.xaxis.tickformat = null;
            } 
          }
          if(dataList.dateList.length < 5) {
            layout.xaxis.nticks = dataList.dateList.length;
          }
          if(dataList.dateList.length >= 5) {
            layout.xaxis.tickmode = 'array';
            layout.xaxis.tickvals = [dataList.dateList[0], dataList.dateList[Math.round((dataList.dateList.length - 1)/2)], dataList.dateList[dataList.dateList.length-1]]
            layout.xaxis.nticks = 3;
            layout.xaxis.tickformat = this.tickformat;
          }
          // layout.xaxis.nticks = 1
          // console.log(traces, layout)
          let config = {responsive: true, displayModeBar: false, scrollZoom: false, showTips: false};
          // eslint-disable-next-line no-undef
          Plotly.newPlot(this.$refs.chart, traces, layout, config);
          // this.$refs.chart.on('plotly_hover', (data) => {          
          //   try {
          //     let dataPoint = data.points[0];
          //     if(dataPoint && dataPoint.data && dataPoint.data.marker) {              
          //       let pn = dataPoint.pointNumber;
          //       // let sizes = dataPoint.data.marker.size;
          //       // sizes[pn] = 8;
          //       // let update = {'marker': {size: sizes}};
          //       let colors = dataPoint.data.marker.color;
          //       colors[pn] = this.lineColor;
          //       // console.log(this.lineColor)
          //       let update = {'marker': {color: colors}};
          //       Plotly.relayout(this.$refs.chart, update, 0);
          //     }
          //   }
          //   catch {
          //     // catch error
          //   }
          // });

          // mouse out on point
          // this.$refs.chart.on('plotly_unhover', (data) => {
          //   try {
          //     let dataPoint = data.points[0];
          //     if(dataPoint && dataPoint.data && dataPoint.data.marker) {
          //       let pn = dataPoint.pointNumber;
          //       // let sizes = dataPoint.data.marker.size;
          //       // sizes[pn] = 0;
          //       // let update = {'marker': {size: sizes}};
          //       let colors = dataPoint.data.marker.color;            
          //       colors[pn] = "transparent";
          //       let update = {'marker': {color: colors}};
          //       Plotly.relayout(this.$refs.chart, update, 0);
          //     }
          //   }
          //   catch {
          //     // catch error
          //   }
          // });
        }
      }, delay)
      
    },

    resizeWindowHandler() {
      // eslint-disable-next-line no-undef
      if(this.$refs.chart) Plotly.relayout(this.$refs.chart, {});
    },
  },
  mounted() {
    setTimeout(() => {
      const resize_ob = new ResizeObserver(() => {
        // this.resizeWindowHandler()
      });
      if(document.querySelector("wy-va-intent-performance")) {
        resize_ob.observe(document.querySelector(".wy-va-intent-performance"));
      }
    }, 0);  
  }
});
</script>

<style lang="scss">
.wy-va-optimization-response-line-chart {
  min-height: 200px;
  border-radius: 10px;
  background-color: transparent;
  padding: 20px 0 2px 0;
  margin-bottom: 10px;

  // .view-by {
  //   text-align: right;
  //   padding-right: 20px;
  //   color: var(--site-font-tertiary-color);
  //   font-size: 14.22px;
  // }

  .title {
    font-size: 21px;
    font-weight: 600;
    line-height: 0;
    margin-left: 25px;
    color: #0B284F;
    padding-bottom: 15px;
  }

  .metrics-chart {
    width: 100%;
    .svg-container .legend .legendlines path.js-line {
      stroke-width: 10px !important;
      stroke-linecap: round;
      d: path("M 20 0 h 1");
    }
    .legendtext {
      transform: translate(-3.04px, -1.25px) !important;
    }
  }
}
.wy-va-optimization-response-line-chart .js-plotly-plot .plotly .cursor-ew-resize {
  cursor: pointer !important;
}
</style>